import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, interval} from 'rxjs';
import {webSocket} from 'rxjs/webSocket';
import {Store} from '../_models/store';
import {StoreService} from './store.service';
import {takeWhile} from 'rxjs/operators';

@Injectable()
export class OrderWebsocketService {

  private orderStatusSocket;
  public orderStatusSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public orderStatusSocketStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  private isSocketActive = true;
  isRetrying = false;

  store: Store;

  constructor(storeService: StoreService) {
    storeService.current.subscribe(store => {
      if(store){
        this.store = store;
        // this.initOrderStatus();
      }
    });
  }

  retry(){
    this.isRetrying = true;
    interval(5000)
    .pipe(takeWhile(() => !this.isSocketActive))
    .subscribe(() => {
      this.initOrderStatus();
    });
  }

  initOrderStatus(){
    // ENG-4418: Complete any existing socket before opening a new one. Without this,
    // calling initOrderStatus() a second time (e.g. via retry logic) leaves the prior
    // WebSocketSubject open, resulting in two active subscribers and duplicate callbacks.
    if (this.orderStatusSocket) {
      this.orderStatusSocket.complete();
      this.orderStatusSocket = null;
    }

    this.orderStatusSocket = webSocket(`${environment.websocketHost}/ws/order/${this.store.id}/status/`);
    this.orderStatusSocket.subscribe(
    (order) => {
      this.isSocketActive = true;
      this.isRetrying = false;
      this.orderStatusSubject.next(order);
      this.orderStatusSocketStatus.next(true);
    },
    (err: any) => {
      this.isSocketActive = false;
      this.orderStatusSocketStatus.next(false);
      if(!this.isRetrying){
        // this.retry();
      }
    });
  }

}
